
import { defineComponent, ref } from "vue";
import NextStepButton from "@/components/NextStepButton.vue";

export default defineComponent({
  name: "PaymentDetails",
  components: { NextStepButton },
  setup() {
    const taxes = ref(0);
    const fee = ref(0);
    const convertToDollars = (amount: number) => {
      return amount.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    };
    const calculateTotal = () => {
      return convertToDollars(taxes.value + fee.value);
    };
    return {
      convertToDollars,
      taxes,
      fee,
      calculateTotal,
    };
  },
});
